import Vue from "vue";
import App from "./App.vue";
import { router } from "./router";
import store from "./store";
import "./plugins/vant";
import commonApi from "./commonApi";

Vue.config.productionTip = false;
// 移动端适配
import 'lib-flexible/flexible';

import "./style/main.scss";

// 引入echarts
// import * as echarts from 'echarts';
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

//引入电子签名
import vueEsign from "vue-esign";
Vue.use(vueEsign)

// 注册必须的组件
echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LineChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
]);

Vue.prototype.$echarts = echarts;

Vue.prototype.trim = function (s) {
  return s.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
};
Vue.prototype.$commonApi = commonApi;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
